import { createAction } from "redux-actions";

// TODO: UPDATE PLACE HOLDER
export const setTmuiProp = createAction(
  "tmui/SET_TMUI_PROP",
  payload => payload
);
